/* Lumera overrides */
(function () {
  /* 1) Dynamic "Ships by" date (~3 days from today) */
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function updateShip() {
    var el = document.querySelector('.lm-ships');
    if (!el) return false;
    var d = new Date(); d.setDate(d.getDate() + 3);
    var dot = el.querySelector('.lm-pulse');
    el.innerHTML = '';
    if (dot) el.appendChild(dot);
    el.appendChild(document.createTextNode('Ships by ' + fmt(d) + ' from US warehouse'));
    return true;
  }
  function initShip() {
    if (updateShip()) return;
    var t = 0; var iv = setInterval(function () { if (updateShip() || ++t > 20) clearInterval(iv); }, 150);
  }

  /* 2) Header cart icon opens the custom cart drawer */
  function openCart(e) {
    var api = window.__lmCart;
    if (!api) return;
    if (e) { e.preventDefault(); e.stopPropagation(); }
    try { if (typeof api.refresh === 'function') api.refresh(); } catch (_) {}
    try { (api.open || api.openInstant).call(api); } catch (_) { window.location.href = '/cart'; }
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('a.header__icon--cart, .header__icon--cart, #cart-icon-bubble, a.header__icon[href*="/cart"]');
    if (t) openCart(e);
  }, true);

  /* 3) Counterfeit warning box (tailored to Lumera) */
  var FONT = 'font-family:Inter,-apple-system,BlinkMacSystemFont,sans-serif !important;';
  function injectCounterfeit() {
    if (document.querySelector('.replica-warning')) return true;
    var pay = document.querySelector('.lm-pay');
    if (!pay) return false;
    var d = document.createElement('div');
    d.className = 'replica-warning';
    d.style.cssText = 'background-color:#fff5f5 !important;color:#0a1628 !important;border:1px dashed #a40101 !important;border-radius:8px !important;padding:10px !important;padding-left:44px !important;margin-top:15px !important;margin-bottom:15px !important;width:100% !important;position:relative !important;text-align:left !important;box-sizing:border-box !important;' + FONT;
    d.innerHTML = '<div class="warning-icon" style="background-color:#a40101 !important;color:#ffffff !important;width:20px !important;height:20px !important;border-radius:50% !important;display:flex !important;align-items:center !important;justify-content:center !important;font-weight:bold !important;flex-shrink:0 !important;font-size:10px !important;position:absolute !important;top:10px !important;left:14px !important;"><svg fill="#ffffff" version="1.1" xmlns="http://www.w3.org/2000/svg" width="16px" height="16px" viewBox="0 0 416.979 416.979"><g><path d="M356.004,61.156c-81.37-81.47-213.377-81.551-294.848-0.182c-81.47,81.371-81.552,213.379-0.181,294.85c81.369,81.47,213.378,81.551,294.849,0.181C437.293,274.636,437.375,142.626,356.004,61.156z M237.6,340.786c0,3.217-2.607,5.822-5.822,5.822h-46.576c-3.215,0-5.822-2.605-5.822-5.822V167.885c0-3.217,2.607-5.822,5.822-5.822h46.576c3.215,0,5.822,2.604,5.822,5.822V340.786z M208.49,137.901c-18.618,0-33.766-15.146-33.766-33.765c0-18.617,15.147-33.766,33.766-33.766c18.619,0,33.766,15.148,33.766,33.766C242.256,122.755,227.107,137.901,208.49,137.901z"/></g></svg></div><div class="warning-content"><div class="warning-title" style="font-size:14px !important;color:#0a1628 !important;font-weight:700 !important;line-height:1.4 !important;' + FONT + '">Counterfeit Warning</div><div class="warning-text" style="font-size:12px !important;letter-spacing:-0.3px !important;color:#0a1628 !important;font-weight:400 !important;line-height:1.6 !important;' + FONT + '">Lumera Milk Thistle Liver Detox is only sold on this website. Any product listed on Amazon, eBay, or other marketplaces is counterfeit and not genuine Lumera.</div></div>';
    pay.parentNode.insertBefore(d, pay);
    return true;
  }
  function initCounterfeit() {
    if (injectCounterfeit()) return;
    var t = 0; var iv = setInterval(function () { if (injectCounterfeit() || ++t > 20) clearInterval(iv); }, 150);
  }

  /* 4) Shipping Protection: max ONE per order + respect customer opt-out */
  var PROT_ID = '53677329809751';
  function protOptedOut() { try { return sessionStorage.getItem('elProtOut') === '1'; } catch (_) { return false; } }
  /* Track the drawer toggle: unchecked = opted out for this session */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-prot]')) {
      try { sessionStorage.setItem('elProtOut', t.checked ? '0' : '1'); } catch (_) {}
    }
  }, true);
  /* If protection ever exceeds qty 1, force it back to exactly 1 */
  function clampProt() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var it = (c.items || []).filter(function (x) { return String(x.variant_id) === PROT_ID; })[0];
      if (it && it.quantity > 1) {
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: 1 }) })
          .then(function () { try { if (window.__lmCart) window.__lmCart.refresh(); } catch (_) {} });
      }
    }).catch(function () {});
  }
  /* Intercept cart adds: strip protection from the payload if opted out; clamp after every add */
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var isAdd = url.indexOf('/cart/add') !== -1;
    if (isAdd && init && typeof init.body === 'string' && protOptedOut()) {
      try {
        var b = JSON.parse(init.body);
        if (b && b.items && b.items.length > 1) { /* only filter multi-item ATC payloads, never the toggle's own add */
          var f = b.items.filter(function (it) { return String(it.id) !== PROT_ID; });
          if (f.length !== b.items.length) {
            init = Object.assign({}, init, { body: JSON.stringify(Object.assign({}, b, { items: f })) });
          }
        }
      } catch (_) {}
    }
    var p = _fetch.call(this, input, init);
    if (isAdd) { p.then(function () { setTimeout(clampProt, 60); }).catch(function () {}); }
    return p;
  };

  function start() { initShip(); initCounterfeit(); }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
